import * as React from 'react'
import { connect } from 'react-redux'
import { ApplicationState } from '../../store'
import { NavLink as RouterNavLink } from 'react-router-dom';
import { Row, Col, Spinner, ListGroup, ListGroupItem, Button, 
    Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Badge, Table } from 'reactstrap';
import { Redirect } from 'react-router-dom';

interface IState {
    modal: boolean
    childTerm : string
    searchSorting : string
    searchSortingDisplay : string
    searchSortingDropDownOpen : boolean
    redirect: boolean
    redirectCourseId: string
}
// Separate state props + dispatch props to their own interfaces.
interface PropsFromState {
    term:string
    sorting:string
    profession:string
    totalDocument : number
    offset : number
    limit : number
    data: any[]
    loading: boolean
}

// We can use `typeof` here to map our dispatch types to the props, like so.
interface PropsFromDispatch {
    onLoadMore: any
    onSorting:any
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch;


class ListResult extends React.Component<AllProps, IState> {
    sortList = [
            {"Display":"Title", "Expression":"c.titleLowercase"},
            {"Display":"Newest", "Expression":"c.publishedDT desc"},
            {"Display":"Organiser", "Expression":"c.organiser.name"},    
            {"Display":"Shortest Video", "Expression":"c.duration"},
            {"Display":"Longest Video", "Expression":"c.duration desc"},
            {"Display":"Lowest Price", "Expression":"c.normalPrice"},
            {"Display":"Highest Price", "Expression":"c.normalPrice desc"}
        ];
    /**
     *
     */
    constructor(props: AllProps) {
        super(props);
        this.state = {
            modal: false,
            childTerm : this.props.term,
            searchSortingDisplay: 'Title',
            searchSorting: this.props.sorting,
            searchSortingDropDownOpen: false,
            redirect: false,
            redirectCourseId : ""
        };

        this.onInputChange = this.onInputChange.bind(this);
        this.onChangeSorting = this.onChangeSorting.bind(this);
        //this.test = this.test.bind(this);
    }
    public componentDidMount() {
        
    }
    componentDidUpdate(prevProps: AllProps) {
        if (prevProps.sorting != this.props.sorting){
            // if (this.props.sorting == ""){
            //     this.setState({ searchSortingDisplay: "Title" });
            // }
            this.setState({ searchSortingDisplay: this.SortExpressionDisplay(this.props.sorting) });
        }
    }

    onInputChange(e:any) {
        this.setState({ childTerm: e.target.value });
    }

    SortExpressionDisplay(sortExpression:string){
        let foundSort = this.sortList.find(e => e.Expression.toLowerCase() === sortExpression.toLowerCase());
        if (foundSort){
            return foundSort.Display;
        }else{
            return this.sortList[0].Display; // Get First
        }
    }

    onChangeSorting(e:any){
        var sortText = e.currentTarget.textContent;
        let foundSort = this.sortList.find(e => e.Display.toLowerCase() === sortText.toLowerCase());
        var sortExpression = "";
        if (foundSort){
            sortExpression = foundSort.Expression;
        }else{
            sortExpression = this.sortList[0].Expression; // Get First
        }
        this.setState({ 
            searchSortingDisplay : sortText, 
            searchSorting: sortExpression}, () => {
            this.props.onSorting(this.state);
        })
    }

    SecondsTohhmmss(totalSeconds:number) {
        var hours   = Math.floor(totalSeconds / 3600);
        var minutes = Math.floor((totalSeconds - (hours * 3600)) / 60);
        var seconds = totalSeconds - (hours * 3600) - (minutes * 60);
      
        // round seconds
        seconds = Math.round(seconds * 100) / 100
      
        var result = (hours < 10 ? "0" + hours : hours);
            result += ":" + (minutes < 10 ? "0" + minutes : minutes);
            result += ":" + (seconds  < 10 ? "0" + seconds : seconds);
        return result;
    }

    onRowSelected(courseId:string, e:any){
        //console.log("Course ID:" +courseId);
        this.setState({redirect : true, redirectCourseId: courseId}, () => {
        });
    }

    FormatDate(date: Date) {
        var displayDate = new Date(date);
        var options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' } as const;
        return displayDate.toLocaleDateString("en-US", options);
    }

    GetImagePath(fileName: string){
        if (fileName && fileName !== ""){
            fileName = fileName.replace("/courses/","").replace("courses/","").replace(".jpg","_xs.jpg");
            return "https://images.ultimatespro.com/images/" + fileName;
        } else{
            return "https://images.ultimatespro.com/images/general/empty_xs.png";
        }
    }

    public render() {   
        const tdStyle = {
             padding : "15px"
          };

        const showLoadMore = (this.props.offset + this.props.limit) < this.props.totalDocument;
        const toggleSortingDropDown = () => this.setState({searchSortingDropDownOpen : !this.state.searchSortingDropDownOpen}); 

        if (this.state.redirect){
            return (
                <Redirect push to={{
                    pathname: '/courses/' + this.state.redirectCourseId
                }} />
                // <Redirect to={"/courses/" + this.state.redirectCourseId } />
            )
        }
        else{
            return (
                <div onScroll={this.props.onLoadMore.bind(this, this.state)}>
                    {/* <h3>{this.props.term} - {this.props.profession} - {this.props.totalDoc} search result(s)</h3> */}
                    
                    <ListGroup>
                        <ListGroupItem>
                            <Row>
                                <Col lg="9" >
                                    <h5>{this.props.totalDocument} result(s) ({this.props.profession == ""? "All Profession": this.props.profession})</h5>
                                </Col>
                                <Col lg="3" >
                                    <Dropdown isOpen={this.state.searchSortingDropDownOpen} toggle={toggleSortingDropDown}>
                                        <DropdownToggle caret color="secondary" block>
                                            <i className="fas fa-sort mr-1"></i>
                                            {this.state.searchSortingDisplay}
                                        </DropdownToggle>
                                        <DropdownMenu>
                                            <DropdownItem header>Sort</DropdownItem>
                                            <DropdownItem divider/>
                                            {
                                                this.sortList.map(item =>(
                                                    <DropdownItem onClick={this.onChangeSorting}>{item.Display}</DropdownItem>
                                                ))
                                            }
                                        </DropdownMenu>
                                    </Dropdown>
                                </Col>
                            </Row>
                        </ListGroupItem>
                        <Table>
                            <thead>
                                <tr>
                                    <th>Pic</th>
                                    <th>Title</th>
                                    <th>Id</th>
                                    <th>Ref.No</th>
                                    <th>Organiser</th>
                                    <th>Status</th>
                                    <th>Published</th>
                                    <th>Expiry</th>
                                    <th>Edit</th>
                                </tr>
                            </thead>
                            <tbody>
                            {
                            this.props.data.map(item =>(
                                <tr key={item.id}>
                                    <th scope="row">
                                        {
                                            <img src= {
                                                item.videoThumbnailURL !== ""? 
                                                    this.GetImagePath(item.videoThumbnailURL) : 
                                                    "http://images.ultimatespro.com/images/general/empty_xs.png"
                                                } 
                                                width="100px"
                                                onClick={this.onRowSelected.bind(this, item.courseId)} 
                                            />
                                        }
                                    </th>
                                    <td>{item.title}</td>
                                    <td>{item.courseId}</td>
                                    <td>{item.referenceNumber}</td>
                                    <td>{item.organiser?.orgName}</td>
                                    <td>{
                                        (item.courseStatus === "Active") && (
                                            <Badge color="success" pill>&nbsp;{item.courseStatus}&nbsp;</Badge>
                                        ) ||
                                        (item.courseStatus === "UnPublished") && (
                                            <Badge color="warning" pill>&nbsp;{item.courseStatus}&nbsp;</Badge>
                                        )}
                                    </td>
                                    <td>{this.FormatDate(item.publishedDT)}</td>
                                    <td>{this.FormatDate(item.expiryDT)}</td>
                                    <td style={{width:"100px"}}><RouterNavLink to={"/courses/" + item.id + "?pk=" + item.period}><Button color="primary"><i className="fas fa-edit mr-1"></i>Edit</Button></RouterNavLink></td>
                                </tr>
                            ))
                            }
    
                         </tbody>
                        </Table>
                        <ListGroupItem key="loadmore">
                            <Row>
                                <Col lg="12">
                                    <Spinner color="warning" hidden={!this.props.loading} />
                                </Col>
                            </Row>
                            <Row>
                                <Col lg="12">
                                    <Button color="secondary" 
                                        onClick={this.props.onLoadMore.bind(this, this.state)} block
                                        hidden={!showLoadMore} >
                                        Load More
                                    </Button>
                                </Col>
                            </Row>
                        </ListGroupItem>
                    </ListGroup>
                </div>
            )
        }
    }
}

// It's usually good practice to only include one context at a time in a connected component.
// Although if necessary, you can always include multiple contexts. Just make sure to
// separate them from each other to prevent prop conflicts.
const mapStateToProps = (state: ApplicationState) => ({
    
})

// mapDispatchToProps is especially useful for constraining our actions to the connected component.
// You can access these via `this.props`.
const mapDispatchToProps = {

}

// Now let's connect our component!
// With redux v4's improved typings, we can finally omit generics here.
export default connect(
    mapStateToProps
)(ListResult)